function hideZeroReviewRatings() {
  document
    .querySelectorAll('[data-bv-show="rating_summary"], [data-bv-show="inline_rating"]')
    .forEach(function (container) {
      const reviewCountElement =
        container.querySelector('.bv_numReviews_text') ||
        container.querySelector('.bv_numReviews_component_container .bv_text');

      if (!reviewCountElement) return;

      const reviewCount = parseInt(
        reviewCountElement.textContent.replace(/\D/g, ''),
        10
      );

      if (reviewCount === 0) {
        container.style.display = 'none';
      }
    });
}

document.addEventListener('DOMContentLoaded', function () {
  hideZeroReviewRatings();

  const observer = new MutationObserver(function () {
    hideZeroReviewRatings();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});